import $ from 'jquery';
import { getTrans } from '@/services/global/translations.interface';
import store from '@/lib/store/index';
import Vue from 'vue';

const mountVueWithComponents = function (tag, component, components, withStore = true, destroy = true) {
	const elements = [...document.getElementsByTagName(tag)];
	const instanceName = (i) =>
		`MountVue${tag.replace(/-./g, (x) => x[1].toUpperCase()).replace(/^./, (x) => x.toUpperCase())}${i}App`;

	if (elements.length !== 0) {
		elements.forEach((el, i) => {
			const vueInstance = new Vue({
				el,
				name: instanceName(i),
				components: Object.assign(components, { [tag]: component.default }),
				store: withStore ? store : null,
				provide: function () {
					return {
						lang: getTrans(),
					};
				},
			});

			if (destroy) {
				$(document).one('pjax:end', () => {
					vueInstance.$destroy();
				});
			}
		});
	}
};

const mountVueComponent = function (tag, component, withStore = true, destroy = true) {
	mountVueWithComponents(tag, component, {}, withStore, destroy);
};

// Function to mount a Vue component directly to a specific DOM element
const mountVueComponentFromElement = function (element, component, name = null, withStore = true, destroy = true) {
	const componentName = name || `${component.name}App`;
	const tag = component.name
		.replace(/([A-Z])/g, '-$1')
		.toLowerCase()
		.replace(/^-/, '');

	const vueInstance = new Vue({
		el: element,
		name: componentName,
		components: {
			[tag]: component,
		},
		store: withStore ? store : null,
		provide: function () {
			return {
				lang: getTrans(),
			};
		},
	});

	if (destroy) {
		$(document).one('pjax:end', () => {
			vueInstance.$destroy();
		});
	}
};

export { mountVueComponent, mountVueWithComponents, mountVueComponentFromElement };
